
export class Command {
    public direction: string;
    public id: number;
    public pilePosition?: Phaser.Geom.Point;

    constructor(id: number, direction: string, pilePosition: Phaser.Geom.Point) {
        this.id = id;
        this.direction = direction;
        this.pilePosition = pilePosition;
    }

    // up 1
    // down 2
    // left 3
    // right 4

    public static CORRECT_COMMANDS: Command[] = [
        { id: 1, direction: "up" },
        { id: 4, direction: "right" },
        { id: 1, direction: "up" },
        { id: 4, direction: "right" },
        { id: 2, direction: "down" },
        { id: 4, direction: "right" },
        { id: 2, direction: "down" },
        { id: 4, direction: "right" },
    ];

}





// WEBPACK FOOTER //
// ./src/games/ProgramRobotGame/objects/Command.ts